module.exports = __webpack_public_path__ + "img/247-Customer-Support.b2beff3.png";